module.exports = __webpack_public_path__ + "img/limited-time-claimed-btn.4175aadb.png";